import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {ItemSummaryDispatcherService} from '../shared/item-summary-dispatcher.service';
import {Subscription} from 'rxjs';
import {ItemBasicInfo} from '../shared/domain/item';
import {UserSessionService} from '@rbaip/ui-component';
import {ITEM_SUMMARY_EXTERNAL_CONFIG_TOKEN} from '../shared/domain';

@Component({
  selector: 'lib-item-summary-dispatcher',
  templateUrl: './item-summary-dispatcher.component.html',
  styleUrls: ['../scss/lib-item-summary.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [{provide: ITEM_SUMMARY_EXTERNAL_CONFIG_TOKEN, useValue: {}}]
})
export class ItemSummaryDispatcherComponent implements OnInit, OnDestroy {

  @Input() assetId: number;
  @Input() equipId: number;
  @Input() fromView: 'AssetPortal' | 'SiteEvent';
  @Input() canAccess: boolean;
  @Input() inputedAppSettings = {};
  @Output() editModeChanged = new EventEmitter<boolean>();

  itemBasicInfo: ItemBasicInfo;
  doneLoading = false;
  private userSessionServiceSubscription: Subscription;

  constructor(private itemSummaryService: ItemSummaryDispatcherService,
              private userSessionService: UserSessionService,
              @Inject(ITEM_SUMMARY_EXTERNAL_CONFIG_TOKEN) public appSettings: any) {
  }

  ngOnInit() {
    if (this.inputedAppSettings) {
      Object.assign(this.appSettings, this.inputedAppSettings);
    }
    this.subscribeUserSessionService();
    this.init();
  }

  ngOnDestroy(): void {
    if (this.userSessionServiceSubscription) {
      this.userSessionServiceSubscription.unsubscribe();
    }
  }

  private subscribeUserSessionService(): void {
    this.userSessionServiceSubscription = this.userSessionService.userChanged
      .subscribe(() => this.init());
  }

  private init() {
    this.doneLoading = false;
    if (this.assetId !== null && this.assetId !== undefined) {
      this.itemSummaryService.getItemBasicInfoByAssetId(this.assetId)
        .subscribe(itemBasicInfo => this.initItemBasicInfo(itemBasicInfo));
    } else if (this.equipId !== null && this.equipId !== undefined) {
      this.itemSummaryService.getItemBasicInfoByEquipId(this.equipId)
        .subscribe(itemBasicInfo => this.initItemBasicInfo(itemBasicInfo));
    }
  }

  private initItemBasicInfo(itemBasicInfo: ItemBasicInfo) {
    this.itemBasicInfo = itemBasicInfo;
    this.doneLoading = true;
  }

  onEditModeChanged(isOnEditMode: boolean) {
    this.editModeChanged.emit(isOnEditMode);
  }
}
